import { TemplateConfig } from '../types';

export const newSemesterSpreadConfig: TemplateConfig = {
  id: 'new-semester-spread',
  name: '新学期牌阵',
  description: '占卜一整个学期的人际关系、发展学业运势走向、注意事项、对于当下这个学期的学习建议',
  cardCount: 8,
  
  fieldDefaults: {
    title: '新学期牌阵',
    customerQuestion: '占卜一整个学期的人际关系、发展学业运势走向、注意事项、对于当下这个学期的学习建议。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 3 行第 2 张牌',
      '请输入第 3 行第 3 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌'
    ],
    cardInfos: [
      '学期前期人际关系发展趋势',
      '学期中期人际关系发展趋势',
      '学期后期人际关系发展趋势',
      '学期前期学业发展趋势',
      '学期中期学业发展趋势',
      '学期后期学业发展趋势',
      '整个学期需要注意的事项',
      '整个学期的建议'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1890ff',
    backgroundColor: '#f0f5ff',
    icon: '📚'
  }
};